module.exports = __webpack_public_path__ + "img/member_male.1d7c4f7a.png";